import { Checkbox } from '@mlm/ui';
import type { Membership } from '../../../lib/api';

/**
 * Per-tier Stairstep participation toggle. Stored top-level on each tier as
 * `config.disable_stairstep` (1 = excluded). An excluded tier never ranks /
 * ranks up and earns no Stairstep distribution; its volume still rolls up to
 * uplines. Lives under the Stairstep ComPlan editor so all Stairstep config is
 * in one place.
 */
export function StairstepExclusionPerTier({
  memberships,
  draft,
  onChange,
  readOnly,
}: {
  memberships: Membership[];
  draft: Record<string, Record<string, unknown>>;
  onChange: (id: string, next: Record<string, unknown>) => void;
  readOnly: boolean;
}) {
  function getExcluded(cfg: Record<string, unknown>): boolean {
    const v = cfg.disable_stairstep;
    return v === 1 || v === true || v === '1';
  }
  function setExcluded(id: string, excluded: boolean) {
    const next = { ...(draft[id] ?? {}) };
    if (excluded) next.disable_stairstep = 1;
    else delete next.disable_stairstep;
    onChange(id, next);
  }

  return (
    <div className="space-y-2">
      <p className="text-[10px] text-muted-foreground">
        Tick a tier to exclude it from Stairstep — its slots never rank or rank
        up and earn no Stairstep distribution. Their purchase volume still counts
        toward their uplines&apos; group volume.
      </p>
      <div className="overflow-x-auto border rounded-md">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 text-xs text-left text-muted-foreground">
            <tr>
              <th className="px-3 py-2 font-medium">Tier</th>
              <th className="px-3 py-2 font-medium">Exclude from Stairstep</th>
            </tr>
          </thead>
          <tbody>
            {memberships.map((m) => (
              <tr key={m.id} className="border-t">
                <td className="px-3 py-1.5 text-xs font-mono" title={m.name}>{m.code}</td>
                <td className="px-3 py-1.5">
                  <Checkbox
                    checked={getExcluded(draft[m.id] ?? {})}
                    disabled={readOnly}
                    onCheckedChange={(v) => setExcluded(m.id, v === true)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
